<template>
  <tr style="border: 1px solid #EBEDF3; border-top: 0" :class="getTime() ? 'bg-lesson' : ''">
    <td style="text-align: start; vertical-align: middle;">
      <div style="width: 200px" class="d-flex justify-content-start align-items-center">
        <div class="day-left">
          <b>Buổi {{ lesson.lesson_alias || lesson.lesson }}</b>
          <div v-if="isMiddleTest" class="">
            Diễn ra trong khoảng 10 ngày tính từ thời gian buổi học trước
          </div>
        </div>
        <div v-if="comingLesson" class="studying ml-6 ">
          <p class="studying-title">
            Lớp đang học tới
          </p>
        </div>
      </div>
    </td>
    <td style="text-align: start;vertical-align: middle;">
      <el-select
          v-model="lesson.teacher_id"
          filterable class="w-100"
          remote
          @change="handleChangeTeacher"
          reserve-keyword
          placeholder="Tìm kiếm giảng viên"
          :remote-method="remoteMethod"
          :loading="loading">
        <el-option
            v-for="item in teacherOptions"
            :key="item.value"
            :label="`${item.label}`"
            :value="item.value">
        </el-option>
      </el-select>
    </td>
    <td style="text-align: start; vertical-align: middle;">
      <div class="d-flex flex-column justify-content-start" v-if="!isMiddleTest">
        <div>{{ lesson.start_time }} - {{ lesson.end_time }} {{ formatDate(lesson.date_only) }}</div>
      </div>
    </td>
    <td style="text-align: start; vertical-align: middle; white-space: nowrap"><span
        :class="{ 'check-main': isMainSchedule, 'check-day': !isMainSchedule }"
        v-if="hasSubfix(lesson)">{{ getSubfix(lesson) }}</span></td>
    <td style="text-align: start; vertical-align: middle;">{{ getTime() ? 'Đã học' : '' }}</td>
    <td style="text-align: start; vertical-align: middle;">
      <span @click="isShowAttendanceDetail = true" style="text-decoration: underline; color: #5E00FF; cursor: pointer">{{ lesson.deduction ?? 0 }} công</span>
    </td>
    <td class="">
      <div v-if="isMiddleTest ">
        <el-button class="text--white btn btn-primary" @click="markMiddleExam()">Chấm Thi giữa kỳ</el-button>
      </div>
      <div v-if="!isMiddleTest" class="">
        <el-dropdown v-if="!(lesson.date > now_date && lesson.type == 'test')" @command="handleCommand">
          <el-button :class="`${getTime() ? 'action-bg' : ''}`">
            Hành động <i class="el-icon-arrow-down el-icon--right down-icon-action action"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="lesson.date <= now_date" command="attendance-lesson"
                              class="hover-dropitem text-center dark">
              <div class="w-100">
                Điểm danh
              </div>
            </el-dropdown-item>
            <el-dropdown-item
                v-if="lesson.type !== '' && lesson.type !== 'test' && lesson.course_schedule_type != 1"
                command="content-homework" class="hover-dropitem text-center">
              <div class="w-100">
                Xem đề BTVN
              </div>
            </el-dropdown-item>
            <el-dropdown-item
                v-if="lesson.type !== 'first' && lesson.type !== 'end' && lesson.type !== 'test' && lesson.course_schedule_type != 1"
                command="give-gift" class="hover-dropitem text-center">
              <div class="w-100">
                Tặng quà
              </div>
            </el-dropdown-item>
            <el-dropdown-item
                v-if="(lesson.type !== 'first' && lesson.type !== 'end' && lesson.type !== 'test') || lesson.course_schedule_type == 1"
                command="comment" class="hover-dropitem text-center">
              <div class="w-100">
                Nhận xét
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-if="lesson.type !== 'test' && lesson.course_schedule_type != 1"
                              command="show-homework" class="hover-dropitem text-center">
              <div>
                Chấm BTVN
              </div>
            </el-dropdown-item>
<!--            <el-dropdown-item v-if="lesson.type !== 'test' && lesson.course_schedule_type != 1"-->
<!--                              command="remark-homework" class="hover-dropitem text-center">-->
<!--              <div>-->
<!--                Chấm BTVN lần 2-->
<!--              </div>-->
<!--            </el-dropdown-item>-->
            <el-dropdown-item v-if="lesson.type !== 'test'" command="content"
                              class="hover-dropitem text-center">
              <div>
                Nội dung bài giảng
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </td>
    <el-dialog
        class="responsive" v-if="isShowAttendanceDetail"
        :visible.sync="isShowAttendanceDetail" :show-close="false"
    >
      <template #title>
        <span style="width: 100%; text-align: start; display: block; font-size: 20px; font-weight: 700">{{ `Công trừ buổi ${lesson.lesson}` }}</span>
      </template>
      <hr style="margin-top: -25px; margin-bottom: 25px;"/>
      <AttendanceDetail :lesson="lesson"/>
      <div style="display: flex; justify-content: end">
        <el-button @click="isShowAttendanceDetail = false" type="info">Đóng</el-button>
      </div>
    </el-dialog>
  </tr>
</template>

<script>
import moment from 'moment';
import {CHANGE_SUBSTITUTE, GET_SUBSTITUTE} from "@/core/services/store/course/classes.module";
import AttendanceDetail from "@/view/pages/classes/components/AttendanceDetail.vue";

export default {
  components: { AttendanceDetail },
  props: {
    lesson: Object,
    lessonList: Array,
  },

  data() {
    return {
      isDisable: '',
      options: [],
      loading: false,
      comingLesson: false,
      dateOnlyNextLesson: null,
      now_date: moment().format("YYYY-MM-DD HH:mm:ss"),
      greaterComingLesson: false,
      indexDate: 0,
      teacherOptions: [],
      typeExam: 2,
      typeMain: 1,
      typeSupport: 11,
      typeEndTestGeneral: 7,
      typeEndTestSpeaking: 8,
      typeEndTest: 9,
      typeFinal: 4,
      typeOpen: 0,
      typeMidTerm1: 5,
      typeMidTerm2: 6,
      queryTeacher: null,
      isShowAttendanceDetail: false,
      lessonComingNumber: 0,
    }
  },
  computed: {
    isMiddleTest() {
      return (this.lesson.type === 'progress_test_1' || this.lesson.type === 'progress_test_2')
    },
    isMainSchedule() {
      return [1, 11].includes(this.lesson.schedule_type)
    }
  },
  mounted() {
    this.checkNextLesson();
    this.teacherOptions = [
        {
            value: this.lesson.teacher_id,
            label: `${this.lesson?.teacher_name} - ${this.lesson.teacher_id + 100000}`,
        }
    ]
    this.getLessonComing()
  },
  watch: {
    lesson: {
      handler() {
        if (this.lesson.type !== 'tutoring') {
          let matchLesson = this.lessonList.findLast(item => new Date(item.date) < new Date());
          let matchIndex = this.lessonList.findLastIndex(item => new Date(item.date) < new Date());
          this.lessonComingNumber = matchLesson.lesson_alias || matchLesson?.lesson
          this.greaterComingLesson = this.lesson.lesson > matchIndex;
          this.comingLesson = matchLesson && matchLesson.learning_schedule_id === this.lesson.learning_schedule_id && matchIndex !== this.lessonList.length - 1;
        }
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    remoteMethod(query) {
        if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getTeacherSubstitute(query)
        }, 400);
      } else {
        this.teacherOptions = [];
      }
    },
    getLessonComing() {
      this.$emit('lessonComing', this.lessonComingNumber)
    },
    handleChangeTeacher(event) {
        console.log(event);
        const payload = {
        teacher_id: this.lesson.teacher_id,
        schedule_id: this.lesson.id,
      }
      this.$store.dispatch(CHANGE_SUBSTITUTE, payload).then(res => {
        if (!res.error) {
          this.$emit('getSchedule')
          this.$message.success('Cập nhật giảng viên thành công!')
        }
      })
    },
    getTeacherSubstitute(name) {
      const payload = {
        teacher: name
      }
      this.$store.dispatch(GET_SUBSTITUTE, payload).then((res) => {
        if (!res.error) {
          this.teacherOptions = res.data.map(item => {
            return {
              label: `${item.name} - ${item.user_id_plus}`,
              value: item.user_id_plus - 100000
            }
          })
        }
      }).catch((e) => {
        console.log(e, 'error')
      })
    },
    formatDate(value) {
      if (!value) return ''
      return moment(value).format('DD-MM-YYYY')
    },
    checkNextLesson() {
      this.lessonList.map((value) => {
        if (value.lesson == this.lesson.lesson + 1) {
          this.dateOnlyNextLesson = value.date;
        }
      })
      if (this.dateOnlyNextLesson) {
        this.dateOnlyNextLesson = moment(this.dateOnlyNextLesson).format("YYYY-MM-DD HH:mm:ss");
      }
    },

    getTime() {
      return new Date(this.lesson.date) < new Date();
    },

    handleCommand(command) {
      let lession_id = this.lesson.lesson;
      let lesson_alias = this.lesson.lesson_alias;
      let starTimeDate = this.lesson.date_only;
      let starTime = this.lesson.start_time;
      if (command == 'show-homework') {
        this.$emit('mark-homeWork', lession_id, this.lesson.learning_schedule_id, this.lesson.center_id, lesson_alias)
      }

      if (command == 'remark-homework') {
        this.$emit('remark-homework', lession_id, this.lesson.learning_schedule_id, this.lesson.center_id, lesson_alias)
      }

      if (command == 'attendance-lesson') {
        this.$emit('attendance-show', this.lesson, this.greaterComingLesson)
      }

      if (command == 'content-homework') {
        const routeData = this.$router.resolve({
          name: "content-homework", params: {id: this.lesson.lesson_alias || this.lesson.lesson},
          query: {classroom_id: this.$route.params.id, learning_schedule_id: this.lesson.learning_schedule_id}
        });
        window.open(routeData.href, '_blank');
      }
      if (command == 'give-gift') {
        this.$emit('give-gift', this.lesson)
      }

      if (command == 'comment') {
        this.$emit('comment', this.lesson)
      }
      if (command == 'content') {
        this.$emit('content', this.lesson)
      }

    },
    hasSubfix(lesson) {
      return lesson && [this.typeSupport, this.typeMain, this.typeExam, this.typeEndTestGeneral, this.typeEndTestSpeaking, this.typeOpen, this.typeFinal, this.typeMidTerm1, this.typeMidTerm2, this.typeEndTest].includes(lesson.schedule_type);
    },
    getSubfix(lesson) {
      if (!this.hasSubfix(lesson) || lesson.schedule_type === 1 || lesson.schedule_type === 11) {
        return "Buổi chính";
      }
      switch (lesson.schedule_type) {
        case this.typeOpen:
          return "Khai giảng";
        case this.typeFinal:
          return "Tổng kết";
        case this.typeMidTerm1:
        case this.typeMidTerm2:
          return "Thi giữa khóa";
        case this.typeEndTestGeneral:
        case this.typeEndTestSpeaking:
        case this.typeEndTest:
          return "Thi cuối khóa";
        default:
          return "Kiểm tra";
      }
    },
    markMiddleExam() {
      let id = this.$route.params.id
      this.$router.push({name: 'midterm-completed-students', params: {id: id}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/custom/custom-teacher-edu.scss";

.mx-datepicker {
  width: 100% !important;
}

el-dialog {
  margin-top: 3vh !important;
}

.el-popper[x-placement^=bottom] {
  margin-top: -11px;
  width: 182px;
  // height: 138px;
}

.check-main {
  border-radius: 5px;
  border: 1px solid #a6a6a6;
  padding: 3px 10px;
  font-size: 11px;
}
</style>